<div class="lua-message-aucune-donnee">
  <lua-icone
  *ngIf="iconName && !isIcon"
  mode="outlined"
  [iconName]="iconName"
  color="Gris2"
  fontSize="40px"
	></lua-icone>
	<lua-icone
		*ngIf="iconName && isIcon"
		mode="outlined"
		[isIcon]="isIcon"
		[customIconName]="iconName"
		color="Gris2"
		height="40px" 
		width="40px"	
		></lua-icone>
  <h4 class="main-text">{{ mainText }}</h4>
  <small *ngIf="subText" class="sub-text">{{ subText }}</small>
  <div *ngIf="buttonLabel" class="boutton">
    <lua-action-secondaire
      [libelle]="buttonLabel"
      [size]="size"
      (click)="onAction($event)"
    ></lua-action-secondaire>
  </div>
</div>
